/* ==========================================================================
   Spark Fitment — estilo via JavaScript (HKI Air Suspension Brasil)

   O script faz duas coisas:
   1. injeta o CSS em uma <style> no <head> (uma única vez);
   2. marca estados nos elementos — .sf-is-filled quando o campo tem valor
      e .sf-is-disabled quando o select está travado — para não depender
      de :has() e para o destaque de "campo preenchido" funcionar.

   Só usa classes/atributos de dados, nunca IDs.
   Onde carregar: veja as opções no fim do arquivo.
   ========================================================================== */

(function () {
  "use strict";

  var STYLE_ID = "hki-spark-fitment-style";
  var ROOT = "[data-spark-fitment]";

  /* ------------------------------------------------------------------------
     TOKENS — ajuste aqui
     ------------------------------------------------------------------------ */

  var CSS = `
  [data-spark-fitment].spark-fitment {
    --sf-brand: #255583;
    --sf-surface: transparent;
    --sf-field-bg: rgba(255, 255, 255, 0.04);
    --sf-line: rgba(255, 255, 255, 0.18);
    --sf-line: color-mix(in srgb, currentColor 22%, transparent);
    --sf-menu-bg: #101010;
    --sf-menu-ink: #ffffff;
    --sf-radius: 4px;
    --sf-field-h: 50px;
    --sf-chevron: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23000' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E");

    /* sobrescreve as variáveis que o app injeta inline no elemento */
    --sf-bg: transparent !important;
    --sf-text: currentColor !important;
    --sf-button: var(--sf-brand) !important;
    --sf-font: inherit !important;

    display: block;
    color: inherit;
    font-family: inherit;
    background: none;
  }

  /* Para fundo CLARO, troque os quatro valores abaixo (descomente):
  [data-spark-fitment].spark-fitment {
    --sf-field-bg: #ffffff;
    --sf-line: rgba(0, 0, 0, 0.16);
    --sf-menu-bg: #ffffff;
    --sf-menu-ink: #111111;
  } */

  .shopify-app-block:has(> .spark-fitment) {
    margin-block: clamp(24px, 5vw, 56px);
  }

  .spark-fitment .spark-fitment__inner {
    max-width: 1180px;
    margin-inline: auto;
    padding: clamp(20px, 3vw, 28px) clamp(16px, 4vw, 32px);
    background: var(--sf-surface);
    border: 1px solid var(--sf-line);
    border-radius: var(--sf-radius);
    box-shadow: none;
  }

  .spark-fitment .spark-fitment__heading {
    margin: 0 0 18px;
    padding-left: 12px;
    border-left: 3px solid var(--sf-brand);
    font-family: inherit;
    font-size: clamp(1.05rem, 1.4vw + 0.8rem, 1.4rem);
    font-weight: 700;
    line-height: 1.2;
    letter-spacing: -0.01em;
    color: inherit;
  }

  .spark-fitment .spark-fitment__fields {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(165px, 1fr));
    gap: 14px;
    align-items: end;
  }

  .spark-fitment .spark-fitment__field {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 7px;
    margin: 0;
    min-width: 0;
  }

  .spark-fitment .spark-fitment__label {
    font-size: 0.78rem;
    font-weight: 600;
    line-height: 1;
    letter-spacing: 0.01em;
    opacity: 0.65;
  }

  .spark-fitment .spark-fitment__select {
    -webkit-appearance: none;
    appearance: none;
    width: 100%;
    height: var(--sf-field-h);
    padding: 0 42px 0 14px;
    font-family: inherit;
    font-size: 0.95rem;
    font-weight: 500;
    color: inherit;
    background: var(--sf-field-bg);
    border: 1px solid var(--sf-line);
    border-radius: var(--sf-radius);
    cursor: pointer;
    text-overflow: ellipsis;
    transition: border-color 0.15s ease, background-color 0.15s ease;
  }

  .spark-fitment .spark-fitment__select:hover:not(:disabled) {
    border-color: color-mix(in srgb, currentColor 45%, transparent);
  }

  .spark-fitment .spark-fitment__select:focus-visible {
    outline: 2px solid var(--sf-brand);
    outline-offset: 2px;
    border-color: var(--sf-brand);
  }

  .spark-fitment .spark-fitment__select:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  /* estado marcado pelo JS: campo com veículo selecionado */
  .spark-fitment .sf-is-filled .spark-fitment__select {
    border-color: color-mix(in srgb, var(--sf-brand) 60%, transparent);
    background: color-mix(in srgb, var(--sf-brand) 8%, var(--sf-field-bg));
  }

  .spark-fitment .spark-fitment__select option {
    background: var(--sf-menu-bg);
    color: var(--sf-menu-ink);
  }

  .spark-fitment .spark-fitment__field::after {
    content: "";
    position: absolute;
    right: 15px;
    bottom: 0;
    width: 13px;
    height: var(--sf-field-h);
    background-color: currentColor;
    opacity: 0.55;
    pointer-events: none;
    -webkit-mask: var(--sf-chevron) center / 13px 13px no-repeat;
    mask: var(--sf-chevron) center / 13px 13px no-repeat;
  }

  .spark-fitment .sf-is-disabled::after {
    opacity: 0.2;
  }

  .spark-fitment .spark-fitment__status {
    margin: 16px 0 0;
    padding-left: 12px;
    border-left: 2px solid var(--sf-brand);
    font-size: 0.9rem;
    line-height: 1.5;
    color: inherit;
    opacity: 0.85;
  }

  .spark-fitment .spark-fitment__status[hidden] {
    display: none;
  }

  @media (max-width: 749px) {
    [data-spark-fitment].spark-fitment {
      --sf-field-h: 46px;
    }
    .spark-fitment .spark-fitment__fields {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 12px;
    }
  }

  @media (max-width: 419px) {
    .spark-fitment .spark-fitment__fields {
      grid-template-columns: minmax(0, 1fr);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .spark-fitment .spark-fitment__select {
      transition: none;
    }
  }
  `;

  /* ------------------------------------------------------------------------
     1. Injeção do CSS
     ------------------------------------------------------------------------ */

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var tag = document.createElement("style");
    tag.id = STYLE_ID;
    tag.textContent = CSS;
    document.head.appendChild(tag);
  }

  /* ------------------------------------------------------------------------
     2. Estados nos elementos
     ------------------------------------------------------------------------ */

  function syncField(select) {
    var field = select.closest(".spark-fitment__field");
    if (!field) return;
    field.classList.toggle("sf-is-filled", select.value !== "");
    field.classList.toggle("sf-is-disabled", select.disabled);
  }

  function syncAll() {
    var selects = document.querySelectorAll(
      ROOT + " .spark-fitment__select"
    );
    for (var i = 0; i < selects.length; i++) syncField(selects[i]);
  }

  /* O app repopula os selects sozinho (ano > marca > modelo...), então
     ouvimos no document: continua funcionando mesmo se ele recriar o DOM. */
  document.addEventListener("change", function (event) {
    var select = event.target;
    if (select && select.classList && select.classList.contains("spark-fitment__select")) {
      syncField(select);
      // os campos seguintes podem ter sido travados/destravados pelo app
      setTimeout(syncAll, 0);
    }
  });

  /* O bloco do app é montado por JS, então esperamos ele aparecer. */
  function watch() {
    syncAll();
    if (!window.MutationObserver) return;
    var pending = null;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(syncAll, 120);
    }).observe(document.body, { childList: true, subtree: true });
  }

  injectStyles();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", watch);
  } else {
    watch();
  }
})();